// extracted by mini-css-extract-plugin
export var tosLink = "_66-0";